import bgm from 'audio/bgm.mp3';
import bgImage from 'images/brand/intro-bg.jpg';

import type { Intro as MenuIntro } from 'components/molecules/Menu';

import type { ImageAlign, TourData } from 'utils/types/customization';

interface ModelConfig {
    tools: {
        info: boolean;
        infoDefaultValue?: boolean;
        position: boolean;
        positionDefaultValue?: boolean;
        highlight: boolean;
        tour: boolean;
        view: boolean;
        floors: boolean;
        share: boolean;
        screenshot: boolean;
        getLocation: boolean;
    };
    menu: boolean;
    music?: string;
    intro?: MenuIntro[];
    displayTourList?: string[];
    defaultTour: string;
    defaultTitle: string;
    tourData: {
        [key: string]: TourData;
    };
    fixedLink: {
        text: string;
        url: string;
    };
}

const modelConfig: ModelConfig = {
    tools: {
        info: true,
        infoDefaultValue: true,
        position: true,
        positionDefaultValue: false,
        highlight: true,
        tour: true,
        view: true,
        floors: false,
        share: true,
        screenshot: false,
        getLocation: false,
    },
    music: bgm,
    menu: true,
    intro: [
        {
            type: 'ZH',
            content: `淨空老法師(1927-2022)是一代高僧、人間佛教的行者,也是一位備受尊崇的世界宗教領袖。他一生無私奉獻,致力於弘揚佛法,是促進人類和平偉大的教育家與精神導師。六十餘年來,老法師講經說法不輟,積極推廣儒釋道文化,並倡導宗教間的和平對話。他以弘法利生為志業,教化無數人,為世界帶來深遠的影響。英國歷史學家湯恩比博士曾言:「欲解決二十一世紀的社會問題,唯有孔孟學說與大乘佛法。」淨空老法師不僅發揚光大淨土宗的修行法門,更強調倫理道德教育,提倡「宗教一家」的理念,認為宗教教育的本質核心即是愛的教育。本次展覽與逢甲大學圖書館聯合主辦,意義非凡,不僅展現老法師對經典智慧與文化傳承發展的重視,也彰顯他在佛學與教育上的具體貢獻。展覽特別走入校園,營造一方福慧增長的空間,讓觀者深刻體悟老法師的慈悲願行,感受其中蘊含的正向能量。

「愛•共善——淨空老法師文物展」 以老法師的弘法歷程為主軸,回顧他生命中的重要時刻,展現其效法佛陀聖哲誠敬修行的人生。展覽主題「愛•共善」寓意「愛心法界,共善同行」,透過珍貴的文物、墨寶、歷史照片與多媒體展示,讓觀者走進這位佛教教育家的生命歷程。特別值得一提的是,老法師的書法墨跡極具文化底蘊,字字珠璣、句句箴言,顯現出佛陀圓滿覺行的清淨智慧,令人深受啟發。

本次展覽適逢全臺首座校園地景建築——「共善樓」 的落成。這座融合人文與自然,展現和諧共生精神的地標建築,由國際建築大師隈研吾精心設計,與逢甲大學秉持「共善教育」的核心價值相互輝映。展覽名稱「愛•共善」亦呼應「共善樓」的啟用,延續「共善」的理念,與淨空老法師「愛心遍法界,善意滿人間」的宏願契合,相得益彰。不僅承載他的身教傳承,更是一場心靈共修之旅,啟迪人們將愛與善行融入日常生活,共同營造祥和、充滿希望的社會,攜手共創美好未來。`,
        },
    ],

    displayTourList: [],
    defaultTour: 'main',
    defaultTitle: '愛・共善—淨空老法師文物展',
    tourData: {
        main: {
            text: '愛・共善—淨空老法師文物展',
            path: '2015',
            title: '愛・共善—淨空老法師文物展',
            cover: bgImage,

            modelId: 'mbXWPg5aLB6',
            sr: '-2.36,1.57',
            ss: '5',

            sweepId: '427ac29d4ab8492da1830b4b155d8fd3',
            position: { x: 1.0981090068817139, y: 1.551949143409729, z: 2.6471633911132812 },
            rotation: { x: -0.03213955973562428, y: 90.03238511530634 },
        },
    },
    fixedLink: {
        text: '華藏淨宗弘化網',
        url: 'https://www.hwadzan.com/',
    },
};

export const imageAlignConfig: {
    default: ImageAlign;
    exceptions: {
        [key: string]: ImageAlign;
    };
} = {
    default: 'center',
    exceptions: {},
};

export default modelConfig;
